export const BS_BODY_BG : string = "--bs-body-bg";

export const BG_COLOUR: string = "--bg-colour";
export const PANEL_COLOUR: string = "--panel-colour";
export const CONTRAST_COLOUR: string = "--contrast-colour";

export const BG_COLOUR_1: string = "--bg-colour-1";
export const BG_COLOUR_2: string = "--bg-colour-2";
export const BG_COLOUR_3: string = "--bg-colour-3";
export const BG_COLOUR_4: string = "--bg-colour-4";

export const BG_DISTANCE_1: string = "--bg-distance-1";
export const BG_DISTANCE_2: string = "--bg-distance-2";
export const BG_DISTANCE_3: string = "--bg-distance-3";
export const BG_DISTANCE_4: string = "--bg-distance-4";